export const tagPresets = {
    // Modelos de impressoras e etiquetas comuns predefinidos
    printers: {
        zebra_9x5: {
            name: "Zebra (9cm x 5cm) - Padrão Horizontal",
            widthMm: 90,
            heightMm: 50,
            showQr: true,
            qrCodePosition: { top: 12, left: 8 },
            qrCodeSizeMm: 25,
            showName: true,
            namePosition: { top: 13, left: 40 },
            nameFontSize: 16,
            showCompany: true,
            companyPosition: { top: 23, left: 40 },
            companyFontSize: 12,
            showRole: true,
            rolePosition: { top: 30, left: 40 },
            roleFontSize: 10,
        },
        brother_10x5: {
            name: "Brother / Zebra (10cm x 5cm) - Horizontal Largo",
            widthMm: 100,
            heightMm: 50,
            showQr: true,
            qrCodePosition: { top: 12, left: 10 },
            qrCodeSizeMm: 25,
            showName: true,
            namePosition: { top: 13, left: 42 },
            nameFontSize: 16,
            showCompany: true,
            companyPosition: { top: 23, left: 42 },
            companyFontSize: 12,
            showRole: true,
            rolePosition: { top: 30, left: 42 },
            roleFontSize: 10,
        },
        zebra_vertical_5x9: {
            name: "Zebra (5cm x 9cm) - Padrão Vertical",
            widthMm: 50,
            heightMm: 90,
            showQr: true,
            qrCodePosition: { top: 50, left: 12 },
            qrCodeSizeMm: 26,
            showName: true,
            namePosition: { top: 12, left: 5 },
            nameFontSize: 15,
            showCompany: true,
            companyPosition: { top: 24, left: 5 },
            companyFontSize: 11,
            showRole: true,
            rolePosition: { top: 32, left: 5 },
            roleFontSize: 10,
        },
        ticket_8x4: {
            name: "Ingresso Térmico Pequeno (8cm x 4cm)",
            widthMm: 80,
            heightMm: 40,
            showQr: true,
            qrCodePosition: { top: 8, left: 6 },
            qrCodeSizeMm: 24,
            showName: true,
            namePosition: { top: 9, left: 35 },
            nameFontSize: 14,
            showCompany: true,
            companyPosition: { top: 19, left: 35 },
            companyFontSize: 10,
            showRole: true,
            rolePosition: { top: 26, left: 35 },
            roleFontSize: 9,
        }
    },
    
    // Configurações personalizadas pré-definidas por ID do Evento
    events: {
        // Exemplo: O evento ID "1" já chega com a configuração Zebra 9x5cm por padrão
        "1": {
            widthMm: 90,
            heightMm: 50,
            showQr: true,
            qrCodePosition: { top: 12, left: 8 },
            qrCodeSizeMm: 25,
            showName: true,
            namePosition: { top: 13, left: 40 },
            nameFontSize: 16,
            showCompany: true,
            companyPosition: { top: 23, left: 40 },
            companyFontSize: 12,
            showRole: true,
            rolePosition: { top: 30, left: 40 },
            roleFontSize: 10,
        }
    }
};

// Configuração padrão absoluta caso não encontre nenhuma outra correspondência
export const defaultTagConfig = tagPresets.printers.zebra_9x5;
